import { API } from "aws-amplify";

export const recordLogoutAudit = async logoutReason => {
  try {
    await API.post("AccountGatewayApi", "/audit/logoff", {
      body: { logoutReason }
    });
  } catch (error) {
    console.error("logout audit failed:", error);
  }
};
